// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"9b7bbdfc","239":"2eac5180","453":"7f4d9e38","514":"f786e791"}[chunkId] + ".chunk.js";
};